export const BRAND_ALIASES = {
  "audi": ["audi", "ауді", "ауди"],
  "bmw": ["bmw", "бмв"],
  "mercedes": ["mercedes", "мерседес", "мерс", "mb"],
  "volkswagen": ["volkswagen", "vw", "фольксваген", "фолькс", "фольц", "вольц", "волькс"],
  "skoda": ["skoda", "škoda", "шкода"],
  "renault": ["renault", "reno", "рено"],
  "toyota": ["toyota", "тойота"],
  "honda": ["honda", "хонда"],
  "nissan": ["nissan", "ніссан", "ниссан"],
  "hyundai": ["hyundai", "хюндай", "хундай"],
  "kia": ["kia", "кіа", "киа"],
  "ford": ["ford", "форд"],
  "opel": ["opel", "опель"],
  "peugeot": ["peugeot", "пежо", "пежу"],
  "citroen": ["citroen", "citroën", "сітроен", "ситроен"],
  "mazda": ["mazda", "мазда"],
  "chevrolet": ["chevrolet", "шевроле"],
  "subaru": ["subaru", "субару"],
  "mitsubishi": ["mitsubishi", "міцубісі", "митсубиси"],
  "tesla": ["tesla", "тесла"],
  "volvo": ["volvo", "вольво"],
  "fiat": ["fiat", "фіат", "фиат"],
  "alfa romeo": ["alfa romeo", "альфа ромео", "альфаромео"],
  "seat": ["seat", "сеат"],
  "porsche": ["porsche", "порше"],
  "land rover": ["land rover", "ленд ровер", "range rover", "рейндж", "рэндж"],
  "geely": ["geely", "джилі", "джили"],
  "chery": ["chery", "чері", "чери"],
  "byd": ["byd", "бід", "бйд"],
  "zaz": ["zaz", "заз"],
  "daewoo": ["daewoo", "дэу", "деу", "део"],
  "uaz": ["uaz", "уаз"],
  "gaz": ["gaz", "газ"],
};

export const MODEL_HINTS = [
  // ВАЗ / Lada класика
  /ваз ?(210[1-9]|211[0-9])/i,
  /лада ?(210[1-9]|211[0-9])/i,

  // Renault
  /reno(?:ault)? ?logan/i, /рено ?логан/i,

  // Volkswagen
  /vw ?(golf|passat|polo|tiguan|touran|touareg)/i,
  /(фолькс|фольц)[\s-]?(гольф|пасат|пол[oо]|тигуан|туран|туарег)/i,
  /volkswagen ?(golf|passat|polo|tiguan|touran|touareg)/i,

  // Skoda
  /шкода ?(октавія|рапі[дт]|коді[аa]к|карок|суперб)/i,
  /skoda ?(octavia|rapid|kodiaq|karoq|superb)/i,

  // Toyota / Honda / ін.
  /toyota ?(corolla|camry|rav4)/i, /(тойота|той[оа]та) ?(королла|камрі|кемрі|рав ?4|рав4)/i,
  /honda ?(civic|accord|cr[- ]?v)/i, /(хонда) ?(сі[вв]ік|акорд|цр[ -]?в)/i,

  // Audi
  /audi ?(a\d|q\d)/i, /ауді ?(a\d|q\d)/i,

  // Mercedes
  /(mercedes|мерседес|мерс)[-\s]?(c|e|s|gl[e]?|glc|gla|gle)\d*/i,

  // Tesla
  /tesla ?model ?[s3xy]/i, /тесла ?модел[ь ]?[s3xy]/i,
];

//Тварини:
export const DOG_BREEDS = [
  "лабрадор", "ретривер", "німецька вівчарка", "овчарка", "такса", "хаскі", "самоїд", "мопс",
  "бігль", "чихуахуа", "йорк", "йоркширський тер’єр", "терʼєр", "спанієль", "доберман",
  "бульдог", "шпіц", "пітбуль", "стаффорд", "коргі", "акіта", "маламут", "ротвейлер",
];

export const CAT_BREEDS = [
  "британська", "шотландська", "бенгальська", "сфінкс", "мейн-кун", "перська", "абіссинська",
];

//Житло:
export const REAL_ESTATE_HINTS = [
  "будинок", "квартира", "кімната", "таунхаус", "котедж", "гараж",
  "ділянка", "земля", "пентхаус", "дуплекс", "мансарда", "лоджія", "тераса",
  "жк", "новобудова", "вторинка",
  "офіс", "склад", "нежитлове", "торгове приміщення",
];

//Для саду та подвір'я:
export const GARDEN_STRUCTURES = [
  "альтанка", "бесідка", "пергола", "лава", "лавочка", "садова лавка",
  "мангал", "барбекю", "качеля", "гойдалка", "парник", "теплиця",
  "навіс", "сарай", "клумба", "грядка", "компостер",
];

export const INTENT_VERBS = {
  trade: ["продам", "продаю", "куплю", "купити", "обмін", "обміняю", "міняю", "міняється"],
  rental: [
    "оренда", "здам", "здаю", "здається", "здам в оренду",
    "на прокат", "прокат", "подобово", "погодинно",
    "довгостроково", "короткостроково",
  ],
};
